import { writable } from "svelte/store";
let CurrentStateStore = writable(null);
export default CurrentStateStore;
